import HomePage from "./pages/HomePage";
import ProductListing from "./components/productListing/ProductListing";
import CreateNewProduct from "./components/productCatalogue/createNewProduct/CreateNewProduct";
import EditProduct from "./components/productCatalogue/createNewProduct/EditProduct";
import DisplayCustomers from "./components/customerManagement/DisplayCustomers";
import CustomerDetails from "./components/customerManagement/CustomerDetails";
import UserManagement from "./components/userManagement/UserManagement";
import LoginScreen from "./components/loginScreen/LoginScreen";
import ForgotPassword from "./components/forgotPassword/ForgotPassword";
import SetNewPasswordScreen from "./components/setNewPasswordScreen/SetNewPasswordScreen";
import PasswordResetConfirmation from "./components/passwordResetConfirmation/PasswordResetConfirmation";
import MyOrders from "./components/myOrders/MyOrders";
import OrderDetails from "./components/allOrdersManagement/OrderDetails";
import OrderSummary from "./components/orderSummary/OrderSummary";
import Cart from "./components/cart/Cart";
import Shipment from "./components/shipmentSummary/Shipment";
import ShipmentSummary from "./components/shipmentSummary/ShipmentSummary";
import HelpAndSupport from "./components/helpSupport/HelpAndSupport";
import { ProductDetails } from "./components/productDetails/ProductDetails";
import InventoryDetails from "./components/inventoryManagement/InventoryDetails";
import InvoiceScreen from "./components/invoiceGeneration/InvoiceScreen";
import CustomerProfile from "./components/profileScreen/CustomerProfile";
import Payment from "./components/payment/Payment";
import Ledger from "./components/ledger/Ledger";

export const loginRoutes = [
  {
    path: "/",
    element: LoginScreen,
  },
  {
    path: "/confirmation",
    element: PasswordResetConfirmation,
  },
  {
    path: "/forgotpassword",
    element: ForgotPassword,
  },
  {
    path: "/setpassword",
    element: SetNewPasswordScreen,
  },
];

export const sellerRoutes = [
  {
    path: "create-new-product",
    element: CreateNewProduct,
  },
  {
    path: "edit-product/:id",
    element: EditProduct,
  },
  {
    path: "products",
    element: ProductListing,
  },
  {
    path: "products/product/:id",
    element: ProductDetails,
  },
  {
    path: "all-customers",
    element: DisplayCustomers,
  },
  {
    path: "customer/:id",
    element: CustomerDetails,
  },
  {
    path: "create-new-customer",
    element: CustomerDetails,
  },
  {
    path: "user-management",
    element: UserManagement,
  },
  {
    path: "orders",
    element: OrderDetails,
  },
  {
    path: "order-summary/:id",
    element: OrderSummary,
  },
  {
    path: "shipment",
    element: Shipment,
  },
  {
    path: "shipment/shipment-summary",
    element: ShipmentSummary,
  },
  {
    path: "inventory",
    element: InventoryDetails,
  },
  {
    path: "invoice-screen/:id",
    element: InvoiceScreen,
  },
  {
    path: "ledgers/:id",
    element: Ledger,
  },
];

export const customerRoutes = [
  {
    path: "home",
    element: HomePage,
  },
  {
    path: "products",
    element: ProductListing,
  },
  {
    path: "products/product/:id",
    element: ProductDetails,
  },
  {
    path: "my-orders",
    element: MyOrders,
  },
  {
    path: "order-summary/:id",
    element: OrderSummary,
  },
  {
    path: "cart",
    element: Cart,
  },
  {
    path: "help-support",
    element: HelpAndSupport,
  },
  {
    path: "customer-profile",
    element: CustomerProfile,
  },
  {
    path: "my-orders/:id/payment",
    element: Payment,
  },
  {
    path: "ledgers",
    element: Ledger,
  },
];
